<template>
  <div class="container">
    <img class="bg" v-show="!isReport" :src="loginBg" alt="">
    <img class="bg" v-show="isReport" :src="activityBg" alt="">
    <div class="verify">
      <template v-if="whiteListTypes.indexOf('1') >= 0 && !isReport">
        <div class="input-wrap">
          <input v-model="aliasValue" class="mobile" :placeholder="`请输入${whiteListAlias}`" />
        </div>
      </template>
      <template v-if="whiteListTypes.indexOf('0') >= 0 && !isReport">
        <div class="input-wrap">
          <input v-model="mobile" class="mobile" placeholder="请输入手机号" />
        </div>
        <div class="input-wrap">
          <input v-model="verifyCode" class="verify-code" placeholder="请输入验证码" />
          <div class="send-btn" @click="handleSendVerifyCode" v-if="timeout <= 0">发送验证码</div>
          <div class="send-btn" v-else>{{ timeout }}s</div>
        </div>
      </template>
      <template v-if="loginBg">
        <div v-if="!isReport" class="submit" @click="handleSubmit">立即报名活动</div>
        <div v-else class="submit is-report">您已报名</div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { login, getActAndReportInfo, getActInfo, getVerCode, report } from "@/api/mutipleDiscount.js"
import { ref, onMounted } from "vue";
import { Toast } from "vant";
import { getQueryString, } from '@/utils/common'
import { getJsApiSignApi } from '@/api/communal'
import store from '@/store'
import { getCookie, setCookie } from '@/utils/cookie'
import { useRoute } from 'vue-router'
import { debounce } from 'lodash'

const loginBg = ref('')
const activityBg = ref('')
const timeout = ref(0)
const mobile = ref('')
const verifyCode = ref('')
const route = useRoute()
const whiteListTypes = ref([])
const whiteListAlias = ref('')
const aliasValue = ref('')
const isReport = ref(false)

onMounted(async () => { 
  /**
   * 下面判断用来解决问题：
   * 1、后端接口返回的token是绑定用户信息+活动信息
   * 2、倘若打开的两个链接活动不一样，第一次进来，缓存住了token，第二次进来要判断清除掉这个token
   */
  const bizNo = getQueryString('bizNo') // 当前链接的bizNo
  // 初始化加载活动背景图
  const activity = await initActivity(bizNo)
  if (isInTimeRange(activity?.startTime, activity?.endTime)) { 
    const oldBizNo = getCookie('mutipleDiscountBizNo') //获取上次缓存的bizNo
    // 如果上次bizNo存在且不等于这次的bizNo，那就清除掉token，缓存住这次的bizNo
    if (oldBizNo && oldBizNo != bizNo) { 
      // 清除token缓存
      setCookie('wechatMutipleDiscountToken', '')
    }
    
    // 缓存业务编号，用来判断下次打开链接是否变更
    setCookie('mutipleDiscountBizNo', bizNo)

    // 取缓存的token，判断是否存在，如果存在就跳过登录
    const token = getCookie('wechatMutipleDiscountToken')
    if (!token) {
      const code = getQueryString('code')
      if (!code) {
        jumpAuth()
      } else {
        // 调用登录方法
        if (bizNo) {
          
          handleLogin(code, bizNo)
        } else {
          Toast({
            message: '活动链接出错',
            type: 'text'
          })
        }
      }
    } else { 
      handleGetInfo()
    }
  } else {
    Toast({
      message: '活动未开始或已结束',
      duration: 0,
      type: 'text'
    })
  }
})

const initActivity = async (bizNo) => { 
  const res = await getActInfo(bizNo)
  return res.data
}

const isInTimeRange = (startTime, endTime) => { 
  // 1. 目标时间（当前时间）
  const target = new Date();
  
  // 2. 转换开始/结束时间为 Date 对象
  const start = new Date(startTime?.replace(/-/g, '/'));
  const end = new Date(endTime?.replace(/-/g, '/'));
  
  // 3. 校验时间格式有效性（无效时间会返回 NaN）
  const isStartValid = !isNaN(start.getTime());
  const isEndValid = !isNaN(end.getTime());
  const isTargetValid = !isNaN(target.getTime());
  
  if (!isStartValid || !isEndValid || !isTargetValid) {
    console.error('时间格式错误！请确保格式为 yyyy-MM-dd HH:mm:ss');
    return false; // 格式错误直接返回不在范围内
  }
  
  // 4. 时间戳比较（闭区间：start <= target <= end）
  const targetTimeStamp = target.getTime();
  const startTimeStamp = start.getTime();
  const endTimeStamp = end.getTime();
  
  // 兼容开始时间可能大于结束时间的异常情况（自动交换）
  const minTime = Math.min(startTimeStamp, endTimeStamp);
  const maxTime = Math.max(startTimeStamp, endTimeStamp);
  
  return targetTimeStamp >= minTime && targetTimeStamp <= maxTime;
}

const handleSubmit = debounce(async () => { 
  const isVerifyPhone = whiteListTypes.value.indexOf('0') >= 0
  const isVerifyAlias = whiteListTypes.value.indexOf('1') >= 0
  /**
   * isVerifyPhone为true时候，需要进行手机必填校验，如果为false，跳过必填校验
   * isVerifyAlias为true时候，需要进行别名必填校验，如果为false，跳过必填校验
   */
  let params = {}
  if (isVerifyPhone && verifyPhone()) {
    params['phone'] = mobile.value
    params['captchaCode'] = verifyCode.value
  } else if (isVerifyPhone && !verifyPhone()) { 
    return
  }
  if (isVerifyAlias && verifyAlias()) { 
    params['whiteListNo'] = aliasValue.value
  }else if (isVerifyAlias && !verifyAlias()) { 
    return
  }
  await report(params)
  Toast({
    message: '报名成功',
    type: 'text'
  })
  // 已报名
  isReport.value = true
}, 200)

const removeUrlParam = (url, paramName) => {
    const urlObj = new URL(url);
    urlObj.searchParams.delete(paramName);
    return urlObj.toString();
}
const handleLogin = async (code, bizNo) => { 
  try { 
    const loginRes = await login({
      code: code,
      bizNo: bizNo
    })
    setCookie('wechatMutipleDiscountToken', loginRes.data)
    handleGetInfo()
  } catch (err) { 
    console.log(err)
    // 如果是获取openid错误，去掉code重新进入页面获取code
    if (err.code == 9999) {
      const newUrl = removeUrlParam(window.location.href, 'code')
      window.location.href = newUrl
    } else { 
      Toast({
        message: err.message,
        type: 'text'
      })
    }
  }
  
}
const handleGetInfo = async () => { 
  try { 
    const info = await getActAndReportInfo()
    const activity = info.data.activity
    loginBg.value = activity.loginBackImage || activity.activityBackImage || ''
    activityBg.value = activity.activityBackImage || ''
    const reportRecord = info.data.record
    document.title = activity.activityTitle || '多笔随机立减活动'
    if (reportRecord) {
      // 已报名
      isReport.value = true
    }
    // 如果管理后台开启白名单检测
    if (activity.whiteListCheck === 1) {
      whiteListAlias.value = activity.whiteListAlias
      activity.whiteListTypes.split(',').forEach(res => { 
        whiteListTypes.value.push(res)
      })
    }
  } catch (err) { 
    setCookie('wechatMutipleDiscountToken', '')
    console.log(err)
  }
}

const verifyAlias = () => { 
  if (!aliasValue.value) {
    Toast({
      message: "请输入" + whiteListAlias.value,
      type: 'text'
    })
    return false
  }
  return true
}
const verifyPhone = () => { 
  if (!mobile.value) {
    Toast({
      message: "请输入手机号",
      type: 'text'
    })
    return false
  }
  if (!/^1\d{10}$/.test(mobile.value)) { 
    Toast({
      message: "请输入正确的手机号",
      type: 'text'
    })
    return false
  }
  return true
}
const handleSendVerifyCode = debounce(async () => {
  if (verifyPhone()) { 
    // 发送短信
    await getVerCode({
      phone: mobile.value
    })
    timeout.value = 60;
    const interval = setInterval(() => { 
      if (--timeout.value <= 0) { 
        clearInterval(interval)
        console.log('clear')
      }
    }, 1000)
  }
}, 500)
// 活动微信授权code后，返回原来页面
const redirect = () => {
  let redirectRoute = store.state.landPageRoute
  redirectRoute = redirectRoute.slice(1)
  let redirectUrl = `${window.location.origin}${process.env.VUE_APP_ROUTER_BASE}${redirectRoute}`
  // hash路由模：
  if (process.env.VUE_APP_ENV === 'local') redirectUrl = `${window.location.origin}${process.env.VUE_APP_ROUTER_BASE}/#/${redirectRoute}`
  // console.log(redirectUrl);
  window.location.replace(redirectUrl)
}
// 微信授权
const jumpAuth = () => {
  const redirectUrl = encodeURIComponent(window.location.href.split('?redirect=')[0])
  // 1.记录上一个页面的地址
  const redirect = route.query.redirect
  if (redirect) {
    store.commit('setLandPage', redirect)
  }

  // 请求接口获取appid
  getJsApiSignApi('wm').then(res => {
    try {
      const appId = res.data.appid
      const scope = 'snsapi_base'  // 静默授权
      // const scope = 'snsapi_userinfo'  // 主动授权
      const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUrl}&response_type=code&scope=${scope}#wechat_redirect`
      window.location.replace(authUrl)
    } catch (error) {
      console.error('微信授权', error);
      return
    }
  }).catch(error => {
    console.error('微信授权', error);
  })
}
</script>

<style lang="less">
.container {
  height: 100vh;
  width: 100vw;
  overflow-y: auto;
  position: relative;
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }
  .verify {
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 20px 40px 40px 40px;
    box-sizing: border-box;
    .input-wrap {
      border: 1px solid #ccc;
      border-radius: 20px;
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 12px;
      box-sizing: border-box;
      margin-bottom: 16px;
      input {
        height: 100%;
        background: transparent;
        font-size: 12px;
      }
      .mobile {
        width: 100%;
      }
      .verify-code {
        flex: 1;
      }
      .send-btn {
        font-size: 12px;
        color: #e10400;
        width: 66px;
        display: flex;
        justify-content: center;
      }
    }
    .submit {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--submit-btn-bg-color, #e10400);
      border-radius: 20px;
      color: var(--submit-btn-font-color, #ffffff);
      font-size: 16px;
    }
    .is-report {
      --submit-btn-bg-color: #ef9491;
      --submit-btn-font-color: #f7cecd;
    }
  }
}
</style>